export const ENDPOINTS = {
  AUTH: {
    CSRF: '/csrf-cookie',
    LOGIN: '/login',
    LOGOUT: '/logout',
    VERIFY: '/verify',
  },
  HUNTER: {
    AVATAR: {
      SHARE: '/me/avatar/share',
      UPDATE: '/me/avatar',
    },
    RIDDLE: {
      STORE: '/me/riddles',
    },
    SHOW: '/me',
    UPDATE: '/me',
  },
  RIDDLE: {
    INDEX: '/riddles',
  },
}
